export default "__VITE_ASSET__DhahiSN2__"